import React from 'react';

export function TrelloCardTemplates() {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.0008 47.0028C64.0008 50.3569 61.2817 53.076 57.9276 53.076H52.3397V48.015H17.9462C14.7624 48.015 12.1509 45.5652 11.8938 42.4478H45.5495V17.6491H11.873L11.873 7.02138C11.873 3.66728 14.5921 0.948242 17.9462 0.948242H57.9277C61.2817 0.948242 64.0008 3.66727 64.0008 7.02137V47.0028Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.3385 17.1434C52.3385 13.7893 49.6195 11.0703 46.2654 11.0703H6.07313C2.71903 11.0703 0 13.7893 0 17.1434V49.0274H52.3385V17.1434ZM45.548 17.6495H6.57875V42.4482H45.548V17.6495Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.2658 63.198C49.6199 63.198 52.339 60.479 52.339 57.1249V49.0273H0V57.1249C0 60.479 2.71903 63.198 6.07313 63.198H46.2658ZM26.0639 53.8353C27.3217 53.8353 28.3413 54.8549 28.3413 56.1127C28.3413 57.3346 27.3791 58.3317 26.1711 58.3877L26.0639 58.3902H8.60366C7.34587 58.3902 6.32623 57.3705 6.32623 56.1127C6.32623 54.8909 7.28844 53.8938 8.49645 53.8378L8.60366 53.8353H26.0639ZM41.7529 52.5701C43.7094 52.5701 45.2955 54.1562 45.2955 56.1128C45.2955 58.0693 43.7094 59.6554 41.7529 59.6554C39.7963 59.6554 38.2102 58.0693 38.2102 56.1128C38.2102 54.1562 39.7963 52.5701 41.7529 52.5701Z"
        fill="currentColor"
      />
    </svg>
  );
}
